export const matchOneRegex = (string, array) => {
  return array.some(regex => {
    if (RegExp(regex.toUpperCase()).test(string?.toUpperCase())) {
      return true
    }
    return false
  })
}
